export default function header() {
    let vuex = JSON.parse(localStorage.getItem('vuex'));
  
    if (vuex && vuex.auth.token) {
      return { Authorization: 'Bearer ' + vuex.auth.token };
    } else {
      return {};
    }
  }